import { useSyncExternalStore } from 'react'

import type { CatalogSelection } from './catalog-picker-modal'
import type { CatalogGroup } from './catalog-picker-modal/mock-catalogs'
import { MOCK_GROUPS } from './catalog-picker-modal/mock-catalogs'

// Design prototype: picked catalogs and groups live outside Redux until the
// search API can filter MDS by catalog. Shared so the Source column header and
// the Source filter next to "+ Filter" always agree.

type State = {
  selection: CatalogSelection
  groups: CatalogGroup[]
}

const initialState = (): State => ({
  selection: { catalogIds: [], groupIds: [] },
  groups: MOCK_GROUPS,
})

let state = initialState()
const listeners = new Set<() => void>()

const setState = (next: Partial<State>) => {
  state = { ...state, ...next }
  listeners.forEach(listener => listener())
}

const subscribe = (listener: () => void) => {
  listeners.add(listener)
  return () => listeners.delete(listener)
}

/** Picked catalogs and groups, plus the user's groups, shared across the page. */
export const useCatalogSelection = () => {
  const { selection, groups } = useSyncExternalStore(subscribe, () => state)
  return {
    selection,
    groups,
    setSelection: (next: CatalogSelection) => setState({ selection: next }),
    setGroups: (next: CatalogGroup[]) => setState({ groups: next }),
  }
}

/** Tests only: module state would otherwise leak between renders. */
export const resetCatalogSelection = () => {
  state = initialState()
  listeners.forEach(listener => listener())
}
